export default __webpack_public_path__ + "static/sky-692d3d582406205a2ef70022063c7c11.png";